(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multi-content"] && !Shopify.designMode) return;
  try {
    
  const selectElement = document.getElementById('languageSelect');
  const contents = document.querySelectorAll('.content');

  selectElement.addEventListener('change', function () {
    const selectedLanguage = selectElement.value + 'Content';

    contents.forEach((content) => {
      content.classList.remove('active');
      if (content.id === selectedLanguage) {
        content.classList.add('active');
      }
    });
  });

  // Initialize to show English content by default
  document.getElementById('EnglishContent').classList.add('active');

  } catch(e) { console.error(e); }
})();
})();
